export const CardImage = {
  transclude: true,

  bindings: {
    img: '<',
    linkText: '<',
    cardClass: '@',
  },

  template: `
    <div class="card card-plain card-inverse card-borderless card-image"
      ng-class="$ctrl.cardClass">
      <image-background src="$ctrl.img">
        <div class="card-block mb-0 align-items-center text-center card-block--tint">
          <ng-transclude></ng-transclude>
        </div>
        <p class="card-link theme-btn--highlight" ng-if="$ctrl.linkText">
          <i class="fa fa-plus-circle"></i>
          {{ $ctrl.linkText }}
        </p>
      </image-background>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Card/CardImage.js